<template lang="pug">
  div
    div
    b-container.content.page-container
      b-row.header
        div
          img(src="../../../assets/logo_big.png")
        div.button-wrapper
          b-dropdown(text="메뉴" right variant="primary")
            b-dropdown-item 홈
            b-dropdown-item 사용 신청
            b-dropdown-item 원격 제어
            b-dropdown-item 이력 관리
            b-dropdown-item 정보 변경
      b-row.title
        div 사용 신청
      b-row
        b-col.mt-4(cols="12")
          div.input-container
            span.text 신 청 업 체 :
            b-form-input(type="text", placeholder="신청 업체" v-model="form.companyName")
          div.input-container
            span.star *
            span 신청자 이름 :
            b-form-input(type="text", placeholder="신청자 이름" v-model="form.applicantName")
          div.input-container
            span.star *
            span 신청자 이메일 :
            b-form-input(type="text", placeholder="신청자 이메일" v-model="form.applicantEmail")
          div.input-container
            span.star *
            span 비 밀 번 호 :
            b-form-input(type="password", placeholder="비밀번호" v-model="form.applicantPw")
          div.input-container
            span.text 신청자 연락처 :
            b-form-input(type="text", placeholder="신청자 연락처" v-model="form.applicantPhone")
          div.input-container
            span.star *
            span 계정 승인 담당자 :
            b-form-input(type="text", placeholder="계정 승인 담당자" v-model="form.approvalManagerName")
          div.input-container
            span.star *
            span 사용 승인 담당자 :
            div.company-container
              b-form-input(type="text", placeholder="사용 승인 담당자" v-model="form.userApproverName")
              b-button(variant="primary", @click="handleSelectButtonClick") 선택
          div.input-container
            span.star *
            span 유효 기간 :
            div.data-picker-container
              b-form-datepicker(v-model="form.startPicked")
              span ~
              b-form-datepicker(v-model="form.endPicked")
          div.input-container
            span.star *
            span 신 청 사 유 :
            div.company-container
              b-form-textarea(id="textarea", v-model="form.textarea", rows="3", placeholder="신청 사유를 입력해주세요.")
          div.input-container
            b-button(variant="primary", @click="handleSendButtonClick",
              style="width: 6rem; font-size: 1.3rem; margin-top: 1.5rem") 신청
</template>

<script>
export default {
  name: 'access-apply',
  methods: {
    handleSelectButtonClick() {
      console.log('handleSelectButtonClick')
    },
    handleSendButtonClick() {
      console.log('handleSendButtonClick')
      console.log(this.form)
    }
  },
  data() {
    return {
      form: {
        companyName: null,
        applicantName: null,
        applicantEmail: null,
        applicantPw: null,
        applicantPhone: null,
        approvalManagerName: null,
        userApproverName: null,
        startPicked: null,
        endPicked: null,
        textarea: '',
      },

    }
  }
}
</script>

<style scoped lang="scss">
.header {
  justify-content: center;
  margin-bottom: 2rem;

  img {
    width: 17rem;
  }

  .button-wrapper {
    position: absolute;
    right: 0;
    top: 53px;
    margin: 1rem;
  }
}

.title {
  justify-content: center;
  margin: 1rem 0 0 0;

  > div {
    font-size: 2rem;
    font-weight: 550;
    letter-spacing: 1px;
  }
}

.input-container {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin: 1rem 0;

  span {
    display: inline-block;
    width: 10rem;
    font-size: 1.1rem;
  }

  .text {
    margin-left: 1rem;
  }

  .star {
    color: red;
    width: 1rem;
    font-size: 1.5rem;
  }

  .company-container {
    display: flex;
    width: 40%;
    margin-left: 1rem;

    .btn {
      margin-left: 1rem;
      width: 3.5rem;
      font-size: 0.75rem;
    }
  }

  .description {
    width: 100%;
    text-align: center;
  }

  .data-picker-container {
    display: flex;
    margin-left: 1rem;
    width: 40%;
    text-align: center;
    align-items: center;

    .form-control {
      font-size: 0.8rem;
    }
  }

  > .form-control {
    margin-left: 1rem;
    width: 40%;
  }
}
</style>
